import { API_ENDPOINTS } from "config/config";
import { buildCanonicalQueryParams } from "utils/dateRangeParams";

export const buildFinanceQueryParams = buildCanonicalQueryParams;

export const getKpis = async (api, params = {}) => {
  const response = await api.get(API_ENDPOINTS.GET_KPI_REPORT, {
    params: buildFinanceQueryParams(params),
  });
  return response.data.data;
};

export const getSalesCount = async (api, params = {}) => {
  const response = await api.get(API_ENDPOINTS.GET_SALES_COUNT, {
    params: buildFinanceQueryParams(params),
  });
  return response.data.data;
};

export const getProfitLoss = async (api, params = {}) => {
  const response = await api.get(API_ENDPOINTS.GET_PROFIT_LOSS_REPORT, {
    params: buildFinanceQueryParams(params),
  });
  return response.data.data;
};

export const getProfitLossTrend = async (api, params = {}) => {
  const { filters, ...rest } = params;
  const response = await api.get(API_ENDPOINTS.GET_PROFIT_LOSS_REPORT, {
    params: buildFinanceQueryParams({
      filters,
      groupBy: "month",
      ...rest,
    }),
  });
  return response.data.data;
};

export const getProductBreakdown = async (api, params = {}) => {
  const response = await api.get(API_ENDPOINTS.GET_PRODUCT_BREAKDOWN, {
    params: buildFinanceQueryParams(params),
  });
  return response.data.data;
};

export const getUpgradeMetrics = async (api, params = {}) => {
  const response = await api.get(API_ENDPOINTS.GET_UPGRADE_METRICS, {
    params: buildFinanceQueryParams(params),
  });
  return response.data.data;
};

export const getSubscriptionMetrics = async (api, params = {}) => {
  const response = await api.get(API_ENDPOINTS.GET_SUBSCRIPTION_METRICS, {
    params: buildFinanceQueryParams(params),
  });
  return response.data.data;
};

export const getAcePerformance = async (api) => {
  const response = await api.get(API_ENDPOINTS.GET_ACE_PROGRESS);
  return response.data.data;
};

export const getCurrentPeriodMonth = () => {
  const now = new Date();
  const y = now.getUTCFullYear();
  const m = String(now.getUTCMonth() + 1).padStart(2, "0");
  return `${y}-${m}`;
};

export const getCommissionDashboardSummary = async (api, { periodMonth } = {}) => {
  const response = await api.get(API_ENDPOINTS.GET_COMMISSION_DASHBOARD_SUMMARY, {
    params: { periodMonth: periodMonth ?? getCurrentPeriodMonth() },
  });
  return response.data.data;
};

export const getStripeReconciliation = async (api) => {
  const response = await api.get(API_ENDPOINTS.GET_STRIPE_RECONCILIATION);
  return response.data.data;
};

export const getStripeDebug = async (api) => {
  const response = await api.get(API_ENDPOINTS.GET_STRIPE_DEBUG);
  return response.data.data;
};
